package top.wcpe.allincore.ui.web.model

import top.wcpe.allincore.ui.runtime.event.HitRegion
import top.wcpe.allincore.ui.web.ModelCompositionRect
import top.wcpe.allincore.ui.web.WebInputOwnerHandler

/**
 * FR-UI-066：交互式 modelPreview 的独占命中 owner。
 * 左键拖拽累加视角偏移；区域由宿主在 compose 时刷新。
 */
internal class ModelPreviewHitOwner(
    private val onDragDelta: (dx: Float, dy: Float) -> Unit,
) : WebInputOwnerHandler {
    private var dragging = false
    private var regionX = 0.0
    private var regionY = 0.0
    private var regionW = 0.0
    private var regionH = 0.0

    /** 当前逻辑矩形（供测试与调试读取）。 */
    fun currentRect(): ModelCompositionRect =
        ModelCompositionRect(regionX.toFloat(), regionY.toFloat(), regionW.toFloat(), regionH.toFloat())

    /** 是否处于拖拽中。 */
    fun isDragging(): Boolean = dragging

    /** 更新命中区域；HitRegion 闭包读取可变字段，无需反复 register。 */
    fun updateRegion(rect: ModelCompositionRect) {
        regionX = rect.x.toDouble()
        regionY = rect.y.toDouble()
        regionW = rect.width.toDouble()
        regionH = rect.height.toDouble()
    }

    fun hitRegion(): HitRegion = HitRegion { x, y ->
        x >= regionX && x < regionX + regionW && y >= regionY && y < regionY + regionH
    }

    override fun pointerDown(x: Double, y: Double, button: Int): Boolean {
        if (button != LEFT_BUTTON) return false
        dragging = true
        return true
    }

    override fun pointerMove(x: Double, y: Double, dx: Double, dy: Double): Boolean {
        if (!dragging) return false
        onDragDelta(dx.toFloat(), dy.toFloat())
        return true
    }

    override fun pointerUp(x: Double, y: Double, button: Int): Boolean {
        if (!dragging) return false
        dragging = false
        return true
    }

    override fun pointerCancel(): Boolean {
        dragging = false
        return true
    }

    private companion object {
        const val LEFT_BUTTON = 0
    }
}
